import moment from 'moment';

export function getLocalIsoString(date?: moment.Moment): string {
  date = date || moment();
  return getIsoString(date.clone().add(date.utcOffset(), 'm').toISOString());
}

export function getIsoString(date: string): string {
  if (typeof date === 'string') {
    const index = date.indexOf('Z');
    if (index > -1) {
      return date.slice(0, index);
    }
  }
  return date;
}
